import OffersEmptyState from 'features/rewards/screens/MyOffers/components/OffersEmptyState/OffersEmptyState';
import UpsideOffersList from 'features/rewards/screens/MyOffers/components/UpsideOffersList/UpsideOffersList';
import { useMyOffersContext } from 'features/rewards/screens/MyOffers/providers/MyOffersProvider';
import React from 'react';

const PendingOffersTab = () => {
  const { upsideOffers, isOverlayLoading, isPageLoading } =
    useMyOffersContext();
  const hasPendingOffers = upsideOffers.length > 0;

  if (!hasPendingOffers && !isOverlayLoading && !isPageLoading) {
    return <OffersEmptyState variant="pendingOffers" />;
  }

  return (
    <UpsideOffersList showSectionHeader={false} showFooterSubtitle={false} />
  );
};

export default PendingOffersTab;
